import { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import * as allauth from '../lib/allauth'
import FormErrors from '../components/FormErrors'
import { useConfig } from '../auth/hooks'
import { Card, Table, Button, Input, Radio, Typography, Space } from 'antd'

const { Title } = Typography

export default function ChangeEmail () {
  const config = useConfig()
  const [email, setEmail] = useState('')
  const [redirectToVerification, setRedirectToVerification] = useState(false)
  const [emailAddresses, setEmailAddresses] = useState([])
  const [response, setResponse] = useState({ fetching: false, content: { status: 200, data: [] } })

  useEffect(() => {
    setResponse((r) => ({ ...r, fetching: true }))
    allauth.getEmailAddresses().then((resp) => { if (resp.status === 200) setEmailAddresses(resp.data) }).then(() => { setResponse((r) => ({ ...r, fetching: false })) })
  }, [])

  function requestRedirectToVerification () { if (config.data.account.email_verification_by_code_enabled) setRedirectToVerification(true) }
  function addEmail () {
    setResponse({ ...response, fetching: true })
    allauth.addEmail(email).then((resp) => { setResponse((r) => ({ ...r, content: resp })); if (resp.status === 200) { setEmailAddresses(resp.data); setEmail(''); requestRedirectToVerification() } }).catch((e) => { console.error(e); window.alert(e) }).then(() => { setResponse((r) => ({ ...r, fetching: false })) })
  }
  function requestEmailVerification (em) {
    setResponse({ ...response, fetching: true })
    allauth.requestEmailVerification(em).then((resp) => { if (resp.status === 200) requestRedirectToVerification() }).catch((e) => { console.error(e); window.alert(e) }).then(() => { setResponse((r) => ({ ...r, fetching: false })) })
  }
  function deleteEmail (em) {
    setResponse({ ...response, fetching: true })
    allauth.deleteEmail(em).then((resp) => { setResponse((r) => ({ ...r, content: resp })); if (resp.status === 200) setEmailAddresses(resp.data) }).catch((e) => { console.error(e); window.alert(e) }).then(() => { setResponse((r) => ({ ...r, fetching: false })) })
  }
  function markAsPrimary (em) {
    setResponse({ ...response, fetching: true })
    allauth.markEmailAsPrimary(em).then((resp) => { setResponse((r) => ({ ...r, content: resp })); if (resp.status === 200) setEmailAddresses(resp.data) }).catch((e) => { console.error(e); window.alert(e) }).then(() => { setResponse((r) => ({ ...r, fetching: false })) })
  }

  if (redirectToVerification) return <Navigate to='/account/verify-email' />

  const cols = [
    { title: 'Email', dataIndex: 'email', key: 'e' },
    { title: 'Verified', dataIndex: 'verified', key: 'v', render: v => v ? '✅' : '❌' },
    { title: 'Primary', key: 'p', render: (_, r) => <Radio checked={r.primary} onChange={() => markAsPrimary(r.email)} /> },
    { title: '', key: 'a', render: (_, r) => (
      <Space size='small'>
        {!r.verified && <Button size='small' onClick={() => requestEmailVerification(r.email)} loading={response.fetching}>Resend</Button>}
        {!r.primary && <Button size='small' className='tti-btn-danger' onClick={() => deleteEmail(r.email)} loading={response.fetching}>Remove</Button>}
      </Space>
    ) }
  ]

  return (
    <div style={{ maxWidth: 600, margin: '0 auto' }}>
      <Title level={2} className='tti-page-title'>Change Email</Title>
      <Card size='small' style={{ marginBottom: 16 }}>
        <Table dataSource={emailAddresses} columns={cols} rowKey='email' size='small' pagination={false} />
      </Card>
      <Card size='small' title='Add Email'>
        <FormErrors errors={response.content.errors} />
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, color: 'var(--tti-muted)' }}>Email</label>
          <Input value={email} onChange={(e) => setEmail(e.target.value)} type='email' style={{ marginTop: 4 }} />
          <FormErrors param='email' errors={response.content?.errors} />
        </div>
        <div style={{ textAlign: 'right' }}>
          <Button type='primary' loading={response.fetching} onClick={() => addEmail()}>Add</Button>
        </div>
      </Card>
    </div>
  )
}
